var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrChartPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#182F43",
    d: "M12.3 10.178c.103.232.225.457.363.67l10.862-2.16A11.962 11.962 0 0 0 8.215.62l4.085 9.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "M12.63 13.742a7.009 7.009 0 0 1-2.169-2.773L6.376 1.406a11.991 11.991 0 1 0 14.512 18.626l-8.258-6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "m14.365 12.549 7.741 5.9A11.916 11.916 0 0 0 24 11.999a12.055 12.055 0 0 0-.08-1.35l-9.555 1.9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrChartPie);
export default __webpack_public_path__ + "static/media/fi-sr-chart-pie.cedfa0b3c1834a599a3627bc6ebf2255.svg";
export { ForwardRef as ReactComponent };